'use client';

import { useSearchParams } from 'next/navigation';

import { cn } from '~/lib/utils';

export function ErrorMessage({ className }: { className?: string }) {
  const searchParams = useSearchParams();
  const error = searchParams.get('error');

  if (error) {
    return (
      <div className={cn('border-l-2 border-l-red bg-red/5 px-4 py-3 leading-tight text-red', className)}>{error}</div>
    );
  }
}
